import React from 'react';
import { Building2 } from 'lucide-react';

type PlaceholderImageProps = {
  name?: string;
  className?: string;
};

const gradients = [
  'from-teal-600 to-teal-800',
  'from-blue-600 to-indigo-800',
  'from-emerald-600 to-emerald-800',
  'from-amber-600 to-orange-700',
  'from-purple-600 to-purple-800',
  'from-rose-600 to-rose-800',
];

function hashIndex(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % gradients.length;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({ name = '', className = '' }) => {
  const gradient = gradients[hashIndex(name)];
  return (
    <div
      className={`flex items-center justify-center bg-gradient-to-br ${gradient} ${className}`}
      role="img"
      aria-label={name || 'Hostel image placeholder'}
    >
      <Building2 className="h-8 w-8 text-white/40" />
    </div>
  );
};

export default PlaceholderImage;
